import React from 'react'

function Doc_quiz({
  setFee, 
  setAgreementq, 
  setUploadagreenment, 
  setPortal, 
  setDocquiz, 
  setFrontid, 
  setBackid, 
  setPropertyimages
}) {

  const yes = () =>{
    setDocquiz(false)
    setUploadagreenment(true)
  }

  const no = () =>{
    setAgreementq(true)
    setDocquiz(false)
  }
  return (
    <div className='doc_inner'>
        <div>
        <p className='fill_In'>Do you have an Agency Property Agreement?</p>
        <div className='submit' onClick={yes}>Yes</div>
        <div className='submit' onClick={no}>No</div>
        </div>
    </div>
  )
}

export default Doc_quiz